  import React, { useEffect, useRef, useState } from 'react'
  import ProjectListTableSearchV2 from './ProjectListTableSearchV2';
  import { useNavigate } from 'react-router-dom';
  import { useLoading } from '@context/LoadingContext';
  import api from '@api/axios';
  import ProjectListTableFinanceV2 from './ProjectListTableFinanceV2';
  import ProjectListTableRowV2 from './ProjectListTableRowV2';
  import moment from 'moment';
import ProjectListTableStatusV2 from './ProjectListTableStatusV2';
  
  const ProjectListTableV2 = () => {
    const { showLoading, hideLoading } = useLoading();
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(30);
    const [projectList, setProjectList] = useState([]);
    const [projectListTotal, setProjectListTotal] = useState(0);
    const [checkedProjectList, setCheckedProjectList] = useState([]);
    const [year, setYear] = useState(moment().year());
    const [yearlyFinance, setYearlyFinance] = useState({});
    const [projectStatus, setProjectStatus] = useState({});

    // 상대적으로 정적으로 관리되는 파라미터 (검색 파라미터)
    const [search, setSearch] = useState({
      projectName: '',
      orderingCompanyName: '',
      accountCompanyName: '',
      projectManagerName: '',
      staffName: '',
      status: '',
      orderBy: 'start_date',
      orderDir: 'DESC',
      isProjectConfirm: true,
      onlyFavorite: false,
    });

    // 체크박스 관리 함수
    const handleCheckboxChange = (e, projectId) => {
      if (e.target.checked) {
        setCheckedProjectList([...checkedProjectList, projectId]);
      } else {
        setCheckedProjectList(checkedProjectList.filter((id) => id !== projectId));
      }
    };

    // 검색 함수 (callback 함수)
    // manualSearch: 입력 파라미터 기반 검색을 의미
    const onSearch = ({page, manualSearch = false, status = '', init = false}) => {
      console.log("검색 함수(onSearch) 호출")

      /** setSearch 정적 파라미터 설정 */

      // 직접 검색 일때 동적 파라미터를 정적 파라미터에 저장. 동적 파라미터 바탕 초기화.
      if (manualSearch) setSearch(getSearch());

      // 사업현황 상태 기반 검색 일때 상태(status)를 정적 파라미터에 저장
      if (status !== '') setSearch({ ...search, status: status });

      // 초기화 검색 일때 정적 파라미터 초기화
      if (init) {
        setSearch({
          projectName: '',
          orderingCompanyName: '',
          accountCompanyName: '',
          projectManagerName: '',
          staffName: '',
          status: '',
          orderBy: 'start_date',
          orderDir: 'DESC',
          isProjectConfirm: true,
          onlyFavorite: false,
        });
      }

      /** params 검색 파라미터 설정 */

      // 검색 파라미터 설정
      let searchParam = {};

      // 직접 검색 일때
      if (manualSearch) {
        searchParam = getSearch();
      }
      // 사업현황 상태 기반 검색 일때
      else if (status !== '') {
        searchParam = { ...search, status: status };
      }
      // 이외 검색 일때
      else {
        searchParam = { ...search };
      }

      // 검색일 때 페이지 초기화 (검색 버튼 클릭 시)
      if (manualSearch) setPage(1);

      // 페이지 번호 설정 (페이지 번호 클릭 시)
      if (page) setPage(page);

      // 검색 파라미터
      let params = {}

      // 초기화 검색
      if (init) {
        params = {
          page: 1,
          limit: limit,
          projectName: '',
          orderingCompany: '',
          accountCompany: '',
          managerName: '',
          staffName: '',
          status: '',
          orderBy: 'start_date',
          orderDir: 'DESC',
          isProjectConfirm: true,
          onlyFavorite: false,
        }
      }
      // 이외 검색
      else {
        params = {
          page: manualSearch ? 1 : page,
          limit: limit,
          projectName: searchParam?.projectName || '',
          orderingCompany: searchParam?.orderingCompanyName || '',
          accountCompany: searchParam?.accountCompanyName || '',
          managerName: searchParam?.projectManagerName || '',
          staffName: searchParam?.staffName || '',
          status: searchParam?.status || '',
          orderBy: searchParam?.orderBy || 'start_date',
          orderDir: searchParam?.orderDir || 'DESC',
          isProjectConfirm: searchParam?.isProjectConfirm || true,
          onlyFavorite: searchParam?.onlyFavorite || false,
        }
      }

      /** API 호출 */
  
      showLoading();
      api.get('/api/project/readProjectList', {
          params: params,
        })
        .then((res) => {
          if (res.status === 200) {
            console.log("사업 목록 조회 함수(onSearch) res")
            console.log(res);
  
            setProjectList(res.data.rows);
            setProjectListTotal(res.data.totalCount);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          hideLoading();
        });
    };

    // 연간 실적 조회 함수
    const getYearlyFinance = (manualSearch = false, status = '', init = false) => {
      console.log("연간 실적 조회 함수(getYearlyFinance) 호출")

      /** params 검색 파라미터 설정 */

      // 검색 파라미터 설정
      const searchParam = manualSearch ? getSearch() : { ...search, status: status ? status : '' };

      let params = {}

      if (init) {
        params = {
          year: year,
          projectName: '',
          orderingCompany: '',
          accountCompany: '',
          managerName: '',
          staffName: '',
          status: '',
          isProjectConfirm: true,
          onlyFavorite: false,
        }
      }
      else {
        params = {
          year: year,
          projectName: searchParam?.projectName || '',
          orderingCompany: searchParam?.orderingCompanyName || '',
          accountCompany: searchParam?.accountCompanyName || '',
          managerName: searchParam?.projectManagerName || '',
          staffName: searchParam?.staffName || '',
          status: searchParam?.status || '',
          isProjectConfirm: searchParam?.isProjectConfirm || true,
          onlyFavorite: searchParam?.onlyFavorite || false,
        }
      }

      /** API 호출 */

      showLoading();
      api
        .get('/api/project/readYearlyFinanceList', {
          params: params,
        })
        .then((res) => {
          if (res.status === 200) {
            console.log("연간 실적 조회 함수(getYearlyFinance) res")
            console.log(res);
            setYearlyFinance(res.data.result[0]);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          hideLoading();
        });
    };

    // 연간 실적 조회 함수
    const getProjectStatus = () => {
      console.log("사업현황 조회 함수(getProjectStatus) 호출")

      showLoading();
      api
        .get('/api/project/readProjectStatus', {
          params: {
            year: year,
          },
        })
        .then((res) => {
          console.log("사업현황 조회 함수(getProjectStatus) res")
          console.log(res);
          
          if (res.status === 200) {
            let projectStatus = {
              progress: 0,
              completed: 0,
              waiting: 0,
              planned: 0,
            };

            res?.data?.result?.forEach((item) => {
              console.log(item);
              if (item.project_status === 'progress') {
                projectStatus.progress = item.project_count;
              } else if (item.project_status === 'completed') {
                projectStatus.completed = item.project_count;
              } else if (item.project_status === 'waiting') {
                projectStatus.waiting = item.project_count;
              } else if (item.project_status === 'planned') {
                projectStatus.planned = item.project_count;
              }
            });

            console.log("사업현황 조회 함수(getProjectStatus) projectStatus");
            console.log(projectStatus);

            setProjectStatus(projectStatus);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          hideLoading();
        });
    };

    useEffect(() => {
      console.log("useEffect 작동");

      getYearlyFinance();
      getProjectStatus();
      onSearch({page: 1, manualSearch: false, status: '', init: false});
    }, [limit, search.orderBy, search.orderDir, search.isProjectConfirm, search.onlyFavorite]);

    const searchRef = useRef();

    const getSearch = () => {
      return searchRef?.current?.getSearch();
    };

    return (
      <React.Fragment>
        <ProjectListTableSearchV2
          onSearch={onSearch}
          getYearlyFinance={getYearlyFinance}
          staticSearch={search}
          setStaticSearch={setSearch}
          ref={searchRef}
        />
  
        <ProjectListTableFinanceV2
          year={year}
          yearlyFinance={yearlyFinance}
        />

        <ProjectListTableStatusV2
          onSearch={onSearch}
          getYearlyFinance={getYearlyFinance}
          navigate={navigate}
          year={year}
          projectStatus={projectStatus}
        />
  
        <ProjectListTableRowV2
          page={page}
          limit={limit}
          staticSearch={search}
          setStaticSearch={setSearch}
          setLimit={setLimit}
          projectList={projectList}
          projectListTotal={projectListTotal}
          checkedProjectList={checkedProjectList}
          handleCheckboxChange={handleCheckboxChange}
          navigate={navigate}
          onSearch={onSearch}
          getYearlyFinance={getYearlyFinance}
          getProjectStatus={getProjectStatus}
        />
      </React.Fragment>
    );
  };
  
  export default ProjectListTableV2;
  